import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = { class: "col-lg-4" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "col-lg-4" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "position-relative" }
const _hoisted_16 = { class: "col-lg-4" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "position-relative" }
const _hoisted_20 = { class: "col-lg-4" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "position-relative" }
const _hoisted_24 = { class: "col-lg-4" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "position-relative" }
const _hoisted_27 = { class: "col-lg-4" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "col-lg-4" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = { class: "col-lg-4" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "col-lg-4" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = { class: "submit-button" }
const _hoisted_40 = {
  key: 0,
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_41 = {
  key: 0,
  class: "card bg-white border-0 rounded-3 mb-4 mt-4"
}
const _hoisted_42 = { class: "card-body p-4" }
const _hoisted_43 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_44 = { class: "table mt-3" }
const _hoisted_45 = { class: "table" }
const _hoisted_46 = { scope: "row" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "d-flex justify-content-around" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  class: "modal fade",
  id: "modalItem",
  tabindex: "-1",
  "aria-labelledby": "modalItemLabel",
  "aria-hidden": "false",
  "data-bs-backdrop": "static"
}
const _hoisted_52 = { class: "modal-dialog" }
const _hoisted_53 = { class: "modal-content" }
const _hoisted_54 = { class: "modal-body" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-lg-12" }
const _hoisted_57 = { class: "form-group" }
const _hoisted_58 = { class: "form-group" }
const _hoisted_59 = {
  key: 0,
  class: "col-lg-12"
}
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = { class: "form-group" }
const _hoisted_62 = { class: "col-lg-6" }
const _hoisted_63 = { class: "form-group" }
const _hoisted_64 = { class: "position-relative" }
const _hoisted_65 = { class: "col-lg-6" }
const _hoisted_66 = { class: "form-group" }
const _hoisted_67 = { class: "position-relative" }
const _hoisted_68 = { class: "col-lg-12" }
const _hoisted_69 = { class: "form-group" }
const _hoisted_70 = { class: "position-relative" }
const _hoisted_71 = { class: "col-lg-12" }
const _hoisted_72 = { class: "form-group" }
const _hoisted_73 = { class: "position-relative" }

import { onMounted, onUnmounted, ref, toRaw, watch } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { formatDate, mapOptionMultiselect } from "@/utils/helper";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { toast } from "vue-sonner";
import { useCategoryStore } from "@/stores/master/category-store";
import { useCategoryGroupStore } from "@/stores/master/category-group-store";
import { useItemStore } from "@/stores/management/item";
import { db } from "@/database/db";
import {
  RequisitionResponse,
  VariantInterface,
} from "@/types/interface/requisition";
import { useRequisitionStore } from "@/stores/management/requisition";
import { useRequisitionItemStore } from "@/stores/management/requisition-item";
import Swal from "sweetalert2";
import { useVesselItemStore } from "@/stores/management/item-vessel";
import isOnline from 'is-online';

interface CheckExisting {
  existance: boolean;
  data: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AddProduct',
  setup(__props) {

const idRequisition = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const vesselItemStore = useVesselItemStore();
const requisitionStore = useRequisitionStore();
const requisitionItemStore = useRequisitionItemStore();
const categoryStore = useCategoryStore();
const groupCategoryStore = useCategoryGroupStore();
const itemStore = useItemStore();
const listItem = ref<any>([]);
const listItemDixie = ref<any>([]);
const modalShow = ref<any>(false);
const queryTemp = ref<any>("");
const itemTemp = ref<any>();
const qtyTemp = ref<any>();
const haveVarian = ref(false);
const listVariant = ref([]);
const variant = ref<VariantInterface>();
const rob = ref(0);
const est_rob = ref(0);
const remark = ref("");
const isEditProduct = ref(false);
const showProductForm = ref(false);
const requisitionDetail = ref<RequisitionResponse>();
const requisitionId = ref<number>();
let modalInstance: any;

const category = ref("");
const categoryVal = ref("");
const group_category = ref("");
const group_categoryVal = ref("");
const port = ref("");
const date = ref("");
const msg_id = ref("");
const vessel = ref("");
const vessel_id = ref("");
const pic_onboard = ref("");
const form_no = ref("");
const ref_no = ref("");
const req_status = ref("");
const priority = ref("");
const remarkReq = ref("");
const maxQuantity = ref("");

const emptyStateModal = () => {
  modalShow.value = false;
  qtyTemp.value = "";
  itemTemp.value = "";
  remark.value = "";
  variant.value = { value: null, label: null };
  rob.value = 0;
  est_rob.value = 0;
  isEditProduct.value = false;
  haveVarian.value = false;
};

const addProductToDixie = async (item: any) => {
  item.forEach(async (element) => {
    await db.product.put({
      requisition_id: requisitionId.value,
      id_product: element?.item_id,
      data: toRaw(element),
      qty: element.qty_required,
      remark: element.remark,
      id_variant: element.variant_id,
      variant: toRaw({
        value: element.variant_id,
        label: element.variant_key + "-" + element.variant_value,
      }),
      rob: element.rob,
    });
  });
};

const loadRequisition = async () => {
  const { success, message } = await requisitionStore.dispatchDetail(
    idRequisition.value
  );
  if (success) {
    requisitionDetail.value = requisitionStore?.requisition?.data;
    category.value =
      requisitionDetail.value.category.code +
      " - " +
      requisitionDetail.value.category.name;
    group_category.value =
      requisitionDetail.value.groupCategory.code +
      " (" +
      requisitionDetail.value.groupCategory.name +
      ")";
    port.value =
      requisitionDetail.value.port.name +
      " - " +
      requisitionDetail.value.port.country;
    categoryVal.value = requisitionDetail.value.category;
    group_categoryVal.value = requisitionDetail.value.groupCategory;
    date.value = formatDate(requisitionDetail.value.created_at);
    msg_id.value = requisitionDetail.value?.groupCategory?.code;
    pic_onboard.value = requisitionDetail.value?.pic_onboard;
    form_no.value = requisitionDetail.value?.form_no;
    ref_no.value = requisitionDetail.value?.ref_no;
    requisitionId.value = requisitionDetail.value.id;
    priority.value = requisitionDetail.value.priority;
    req_status.value = requisitionDetail.value.requisition_status?.name;
    remarkReq.value = requisitionDetail.value.remarks;
    showProductForm.value = true;
    buildQuery();
    // if (requisitionDetail.value?.requisitionItem.length > 0) {
    //   addProductToDixie(requisitionDetail.value.requisitionItem);
    // }
    loadProductFromDixie();
  }
};

const loadDataItem = async () => {
  const { success, message } = await itemStore.dispatchGetCatalogs(
    1,
    99,
    queryTemp.value
  );
  if (success) {
    listItem.value = mapOptionMultiselect(
      await itemStore.items?.items,
      "id",
      "name"
    );
  }
};

const loadUserLogin = async () => {
  let getDataLogin = await db.storage.get("login-info");
  let userLogin = getDataLogin?.data;
  vessel.value = `${userLogin?.vessel?.name} (${userLogin?.vessel?.call_sign})`;
  vessel_id.value = userLogin?.vessel?.id;
};

const loadProductFromDixie = async () => {
  const products = await db.product
    .where({ requisition_id: requisitionId.value })
    .toArray();
    console.log(products);
  listItemDixie.value = products;
};

const buildQuery = async (search = "") => {
  queryTemp.value = "";
  if (categoryVal.value != undefined) {
    const { success } = await categoryStore.dispatchDetail(
      categoryVal.value?.id
    );
    if (success) {
      queryTemp.value =
        queryTemp.value + "&category_code=" + categoryStore.category.data.code;
    }
  }

  if (group_categoryVal.value != undefined) {
    const { success } = await groupCategoryStore.dispatchDetail(
      group_categoryVal.value?.id
    );
    if (success) {
      queryTemp.value =
        queryTemp.value +
        "&group_category_code=" +
        groupCategoryStore.categoryGroup.data.code;
      msg_id.value = groupCategoryStore.categoryGroup.data.code;
    }
  }

  if (search != undefined) {
    queryTemp.value = queryTemp.value + "&keyword=" + search;
  }

  loadDataItem();
};

let debounceTimeoutItem: any;

const handleSearch = (query: string) => {
  clearTimeout(debounceTimeoutItem);
  debounceTimeoutItem = setTimeout(() => {
    buildQuery(query);
  }, 500);
};

const loadDetailProduct = async (id: string) => {
  const { success } = await itemStore.dispatchDetail(id);
  if (success) {
    return itemStore.item?.data;
  }
};

const loadSpecificDetail = async (id: string) => {
  let queryParams = "?vessel_id=" + vessel_id.value + "&goods_id=" + id;
  if (haveVarian.value) {
    queryParams = queryParams + "&variant_id=" + variant.value?.value;
  }
  const { success } = await vesselItemStore.dispatchSpecificDetail(queryParams);
  if (success) {
    rob.value = vesselItemStore.vesselItem?.data?.rob;
    maxQuantity.value = vesselItemStore.vesselItem?.data?.quantity;
    return vesselItemStore.vesselItem?.data;
  }
};

const chooseVariant = async () => {
  let specificDetail = await loadSpecificDetail(itemTemp.value?.value);
};

const chooseItem = async () => {
  let detailProduct = await loadDetailProduct(itemTemp.value?.value);
  let specificDetail = await loadSpecificDetail(itemTemp.value?.value);
  if (detailProduct?.variant.length > 0) {
    haveVarian.value = true;
    listVariant.value = mapOptionMultiselect(
      detailProduct?.variant,
      "id",
      "key",
      "value"
    );
  } else {
    haveVarian.value = false;
    listVariant.value = [];
  }
};

const existingProduct = async (
  idProduct: number,
  idVariant: number
): Promise<CheckExisting> => {
  let existing = null;
  if (haveVarian.value) {
    existing = await db.product
      .where({
        id_product: idProduct,
        id_variant: idVariant,
        requisition_id: requisitionId.value,
      })
      .first();
    if (!existing && isEditProduct.value == true) {
      existing = await db.product
        .where({ id_product: idProduct, requisition_id: requisitionId.value })
        .first();
    }
  } else {
    existing = await db.product
      .where({ id_product: idProduct, requisition_id: requisitionId.value })
      .first();
  }
  return {
    existance: !!existing,
    data: existing,
  };
};

const addItemDixie = async () => {
  let error = 0;
  let errMessage = "";
  if (itemTemp.value == undefined && error == 0) {
    error = 1;
    errMessage = "Item can not empty";
  }

  if (qtyTemp.value == undefined && error == 0) {
    error = 1;
    errMessage = "Qty Required can not empty";
  }

  if (remark.value == "" && error == 0) {
    error = 1;
    errMessage = "Remark can not empty";
  }

  if (await isOnline()) {
    const variantExist = variant.value?.value ? variant.value?.value : null;
    const responseCheck = await requisitionItemStore.dispatchCheckExistingRequest(Number(vessel_id.value), itemTemp.value?.value, variantExist);

    if (responseCheck.data) {
      Swal.fire({
        title: "The item is already requested.",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Yes",
        denyButtonText: `No`,
        text: responseCheck.message,
      }).then(async (result) => {
        if (result.isConfirmed) {

          if (error == 0) {
            if (qtyTemp.value + rob.value <= maxQuantity.value) {
              let detailProduct = await loadDetailProduct(itemTemp.value?.value);
              let resultExisiting = await existingProduct(
                itemTemp.value?.value,
                variant.value?.value
              );
              if (isEditProduct.value) {
                await db.product.update(resultExisiting.data.id, {
                  qty:
                    isEditProduct.value == true
                      ? qtyTemp.value
                      : qtyTemp.value + resultExisiting.data.qty,
                  variant: toRaw(variant.value),
                  rob: rob.value,
                  est_rob: est_rob.value,
                  remark: remark.value,
                });
                toast.success("Item successfully updated");
              } else {
                if (!resultExisiting.existance) {
                  await db.product.put({
                    requisition_id: requisitionId.value,
                    id_product: detailProduct?.id,
                    data: toRaw(detailProduct),
                    qty: qtyTemp.value,
                    id_variant: variant.value?.value,
                    variant: toRaw(variant.value),
                    remark: remark.value,
                    rob: rob.value,
                    est_rob: est_rob.value,
                  });
                  toast.success("Item successfully added");
                } else {
                  await db.product.update(resultExisiting.data.id, {
                    qty:
                      isEditProduct.value == true
                        ? qtyTemp.value
                        : qtyTemp.value + resultExisiting.data.qty,
                    variant: toRaw(variant.value),
                    rob: rob.value,
                    est_rob: est_rob.value,
                    remark: remark.value,
                  });
                  toast.success("Item successfully updated");
                }
              }
              emptyStateModal();
              loadProductFromDixie();
            } else {
              toast.error(
                `'Can not input qty required more than max capacity of item, the max capacity is ${maxQuantity.value}'`
              );
            }
          } else {
            toast.error(errMessage);
          }
          
        }
      });
    } else {
      if (qtyTemp.value + rob.value <= maxQuantity.value) {
        let detailProduct = await loadDetailProduct(itemTemp.value?.value);
        let resultExisiting = await existingProduct(
          itemTemp.value?.value,
          variant.value?.value
        );
        if (isEditProduct.value) {
          await db.product.update(resultExisiting.data.id, {
            qty:
              isEditProduct.value == true
                ? qtyTemp.value
                : qtyTemp.value + resultExisiting.data.qty,
            variant: toRaw(variant.value),
            rob: rob.value,
            est_rob: est_rob.value,
            remark: remark.value,
          });
          toast.success("Item successfully updated");
        } else {
          if (!resultExisiting.existance) {
            await db.product.put({
              requisition_id: requisitionId.value,
              id_product: detailProduct?.id,
              data: toRaw(detailProduct),
              qty: qtyTemp.value,
              id_variant: variant.value?.value,
              variant: toRaw(variant.value),
              remark: remark.value,
              rob: rob.value,
              est_rob: est_rob.value,
            });
            toast.success("Item successfully added");
          } else {
            await db.product.update(resultExisiting.data.id, {
              qty:
                isEditProduct.value == true
                  ? qtyTemp.value
                  : qtyTemp.value + resultExisiting.data.qty,
              variant: toRaw(variant.value),
              rob: rob.value,
              est_rob: est_rob.value,
              remark: remark.value,
            });
            toast.success("Item successfully updated");
          }
        }
        emptyStateModal();
        loadProductFromDixie();
      } else {
        toast.error(
          `'Can not input qty required more than max capacity of item, the max capacity is ${maxQuantity.value}'`
        );
      }
    } 

    return;
  } else {
    const param = {
      requisition_id: requisitionId.value,
      id_product: itemTemp.value?.value,
    };
    
    if (variant.value?.value) param.id_variant = variant.value?.value;

    let resultExisiting = db.product.get(param);

    if (resultExisiting?.id) {
      await db.product.update(resultExisiting.id, {
        qty:
          isEditProduct.value == true
            ? qtyTemp.value
            : qtyTemp.value + resultExisiting.qty,
        variant: toRaw(variant.value),
        rob: rob.value,
        est_rob: est_rob.value,
        remark: remark.value,
      });
      toast.success("Item successfully updated");
    } else {
      await db.product.put({
        requisition_id: requisitionId.value,
        id_product: itemTemp.value?.value,
        // data: toRaw(resultExisiting),
        qty: qtyTemp.value,
        id_variant: variant.value?.value,
        // variant: toRaw(variant.value),
        remark: remark.value,
        rob: rob.value,
        est_rob: est_rob.value,
      });
      toast.success("Item successfully added");
    }

    emptyStateModal();
    loadProductFromDixie();
    return;
  }

};

const handleEditProduct = async (id: number) => {
  isEditProduct.value = true;
  loadDataItem();
  modalShow.value = true;
  let getDataTemp = await db.product.get(id);
  if (getDataTemp.data?.name === undefined) {
    itemTemp.value = mapOptionMultiselect(
      getDataTemp?.data,
      "item_id",
      "item_name"
    );
  } else {
    itemTemp.value = mapOptionMultiselect(getDataTemp?.data, "id", "name");
  }
  qtyTemp.value = getDataTemp?.qty;
  est_rob.value = getDataTemp?.rob;
  remark.value = getDataTemp?.remark;
  let detailProduct = await loadDetailProduct(getDataTemp?.id_product);
  if (getDataTemp?.variant != undefined) {
    listVariant.value = mapOptionMultiselect(
      detailProduct?.variant,
      "id",
      "key",
      "value"
    );
    haveVarian.value = true;
    variant.value = getDataTemp?.variant;
  } else {
    haveVarian.value = false;
  }
  let specificDetail = await loadSpecificDetail(getDataTemp?.id_product);
};

const handleDeleteProduct = async (id: number) => {
  await db.product.delete(id);
  toast.error("Successfully delete item");
  loadProductFromDixie();
};

const doSubmitRequisition = async (status = "") => {
  let submitPayload = {};
  let itemRequisition = [];
  let products = await db.product
    .where({ requisition_id: requisitionId.value })
    .toArray();

  products.forEach((element) => {
    itemRequisition.push({
      goods_id: element.id_product,
      variant_id: element.id_variant ? element.id_variant : null,
      rob_estimate: element.rob,
      qty_required: element.qty,
      remarks: element.remark,
    });
  });

  submitPayload.requisition_id = requisitionId.value;
  submitPayload.status = status;
  submitPayload.item = itemRequisition;

  if (itemRequisition.length < 1) {
    toast.error('Requisition items cannot be empty.');
    return;
  }

  const {success, message} = await requisitionItemStore.dispatchCreate(
    submitPayload
  ).catch((error) => {toast.error(error.message);});

    const submitDraft = await requisitionStore.dispatchSubmitDraft(
      idRequisition.value,
    ).catch((error) => {toast.error(error.message);});

  if (submitDraft?.success) {
    toast.success("Successfully submit requisition form");
    setTimeout(() => {
      router.push("/management/requisition");
    }, 1500);
  } else {
    toast.error(submitDraft?.message);
  }
  await db.product.where({ requisition_id: requisitionId.value }).delete();
};

const doSubmitDraft = () => {
  toast.info("Your data will be save as draft");

  setTimeout(() => {
    router.push("/management/requisition");
  }, 1000);
};

onMounted(() => {
  setTimeout(() => {
    const modalEl = document.getElementById("modalItem");
    if (modalEl) {
      const bootstrap = (window as any).bootstrap;
      modalInstance = new bootstrap.Modal(modalEl);
    }
  }, 1000);
  loadUserLogin();
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idRequisition.value = router.currentRoute.value.params.id.toString();
    loadRequisition();
  }
});

const backToListRequisition = () => {
  handleBeforeReloadModal("/management/requisition");
};

const handleBeforeReloadModal = (to: any) => {
  Swal.fire({
    title: "Are you sure want to leave requisition page ?",
    showDenyButton: true,
    showCancelButton: false,
    confirmButtonText: "Yes",
    denyButtonText: `No`,
    text: "All data will deleted, unless you already save before",
  }).then((result) => {
    if (result.isConfirmed) {
      router.push(to);
    }
  });
};

watch(modalShow, (newVal) => {
  if (modalInstance) {
    if (newVal) {
      modalInstance.show();
    } else {
      modalInstance.hide();
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
              _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "mb-0" }, "Form Create Requisition", -1)),
              _createElementVNode("a", {
                class: "btn btn-danger fw-semibold text-white px-3 btn-back",
                type: "button",
                onClick: backToListRequisition
              }, _cache[20] || (_cache[20] = [
                _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }, null, -1),
                _createTextVNode(" Back To List Requisition ")
              ]))
            ]),
            (isLoading.value)
              ? (_openBlock(), _createBlock(BaseLoading, {
                  key: 0,
                  text: "Processing Data..."
                }))
              : _createCommentVNode("", true),
            (!isLoading.value)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 1,
                  onSubmit: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
                  class: "row g-3 needs-validation form"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[22] || (_cache[22] = _createElementVNode("label", {
                          for: "vessel",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Vessel "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_8, [
                          _withDirectives(_createElementVNode("input", {
                            name: "vessel",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vessel).value = $event)),
                            placeholder: "Vessel",
                            type: "text",
                            class: "form-control text-dark",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, vessel.value]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _cache[23] || (_cache[23] = _createElementVNode("label", {
                          for: "port",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Port "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _withDirectives(_createElementVNode("input", {
                              name: "port",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((port).value = $event)),
                              placeholder: "Port",
                              type: "text",
                              class: "form-control text-dark",
                              readonly: ""
                            }, null, 512), [
                              [_vModelText, port.value]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _cache[24] || (_cache[24] = _createElementVNode("label", {
                          for: "date",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Date Receipt "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            name: "date",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((date).value = $event)),
                            placeholder: "Date Receipt",
                            type: "date",
                            class: "form-control text-dark",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, date.value]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[25] || (_cache[25] = _createElementVNode("label", {
                          for: "category",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Category "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _withDirectives(_createElementVNode("input", {
                              name: "category",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((category).value = $event)),
                              placeholder: "category",
                              type: "text",
                              class: "form-control text-dark",
                              readonly: ""
                            }, null, 512), [
                              [_vModelText, category.value]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _cache[26] || (_cache[26] = _createElementVNode("label", {
                          for: "group_category",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Group Category "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _withDirectives(_createElementVNode("input", {
                              name: "group_category",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((group_category).value = $event)),
                              placeholder: "group_category",
                              type: "text",
                              class: "form-control text-dark",
                              readonly: ""
                            }, null, 512), [
                              [_vModelText, group_category.value]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _cache[27] || (_cache[27] = _createElementVNode("label", {
                          for: "msg_id",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("MSG ID "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_26, [
                          _withDirectives(_createElementVNode("input", {
                            name: "msg_id",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((msg_id).value = $event)),
                            placeholder: "MSG ID",
                            type: "text",
                            class: "form-control text-dark",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, msg_id.value]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _cache[28] || (_cache[28] = _createElementVNode("label", {
                          for: "pic",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("PIC Onboard "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_29, [
                          _withDirectives(_createElementVNode("input", {
                            name: "pic",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((pic_onboard).value = $event)),
                            placeholder: "PIC Onboard",
                            type: "text",
                            class: "form-control text-dark",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, pic_onboard.value]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _cache[29] || (_cache[29] = _createElementVNode("label", {
                          for: "priority",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Priority "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_32, [
                          _withDirectives(_createElementVNode("input", {
                            name: "priority",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((priority).value = $event)),
                            placeholder: "Priority",
                            type: "text",
                            class: "form-control text-dark",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, priority.value]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _cache[30] || (_cache[30] = _createElementVNode("label", {
                          for: "req_status",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Requisition Status "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_35, [
                          _withDirectives(_createElementVNode("input", {
                            name: "req_status",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((req_status).value = $event)),
                            placeholder: "Requisition Status",
                            type: "text",
                            class: "form-control text-dark",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, req_status.value]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _cache[31] || (_cache[31] = _createElementVNode("label", {
                          for: "remarkReq",
                          class: "form-label label text-secondary"
                        }, [
                          _createTextVNode("Remark "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_38, [
                          _withDirectives(_createElementVNode("textarea", {
                            name: "remarkReq",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((remarkReq).value = $event)),
                            placeholder: "Requisition Remark",
                            type: "text",
                            class: "form-control text-dark",
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, remarkReq.value]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-info me-3 text-white btn-draft",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (doSubmitDraft()))
                    }, " Save As Draft "),
                    (showProductForm.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-primary btn-submit",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (doSubmitRequisition('submit')))
                        }, " Submit Form Requisition "))
                      : _createCommentVNode("", true)
                  ]),
                  (!showProductForm.value)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_40, " Create Form Requisition "))
                    : _createCommentVNode("", true)
                ], 32))
              : _createCommentVNode("", true)
          ])
        ]),
        (showProductForm.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (modalShow.value = true))
                  }, " Add Item ")
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("table", _hoisted_45, [
                    _cache[32] || (_cache[32] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { scope: "col" }, "No"),
                        _createElementVNode("th", { scope: "col" }, "Item Description"),
                        _createElementVNode("th", { scope: "col" }, "Remark"),
                        _createElementVNode("th", { scope: "col" }, "Qty Required"),
                        _createElementVNode("th", { scope: "col" }, "Unit"),
                        _createElementVNode("th", { scope: "col" }, "ROB"),
                        _createElementVNode("th", { scope: "col" }, "EST ROB"),
                        _createElementVNode("th", { scope: "col" }, "IMPA"),
                        _createElementVNode("th", { scope: "col" }, "MSG CODE"),
                        _createElementVNode("th", { scope: "col" }, "Action")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listItemDixie.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index + 1
                        }, [
                          _createElementVNode("th", _hoisted_46, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(item?.data?.name ?? item?.data?.item_name) + " ", 1),
                            (item.variant?.value != null)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_47, "- " + _toDisplayString(item?.variant?.label), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(item?.remark), 1),
                          _createElementVNode("td", null, _toDisplayString(item?.qty), 1),
                          _createElementVNode("td", null, _toDisplayString(item?.data?.unitType?.name ?? item?.data?.unit), 1),
                          _createElementVNode("td", null, _toDisplayString(item?.rob), 1),
                          _createElementVNode("td", null, _toDisplayString(item?.est_rob), 1),
                          _createElementVNode("td", null, _toDisplayString(item?.data?.impa_code), 1),
                          _createElementVNode("td", null, _toDisplayString(item?.data?.msg_code), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-success text-white btn-edit",
                                onClick: ($event: any) => (handleEditProduct(item?.id))
                              }, " Edit ", 8, _hoisted_49),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-danger btn-delete",
                                onClick: ($event: any) => (handleDeleteProduct(item?.id))
                              }, " Delete ", 8, _hoisted_50)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", { class: "modal-header" }, [
            _cache[33] || (_cache[33] = _createElementVNode("h5", {
              class: "modal-title",
              id: "modalItemLabel"
            }, "Modal Form Add Item", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: emptyStateModal
            })
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _cache[34] || (_cache[34] = _createElementVNode("label", {
                    for: "item",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Item "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_unref(vSelect), {
                      modelValue: itemTemp.value,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((itemTemp).value = $event)),
                      options: listItem.value,
                      placeholder: "Choose Item",
                      onSearch: handleSearch,
                      onClose: chooseItem
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])
              ]),
              (haveVarian.value && (listVariant.value.length > 0))
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _cache[35] || (_cache[35] = _createElementVNode("label", {
                        for: "varian",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Varian "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_61, [
                        _createVNode(_unref(vSelect), {
                          modelValue: variant.value,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((variant).value = $event)),
                          options: listVariant.value,
                          placeholder: "Choose Varian Item",
                          onClose: chooseVariant
                        }, null, 8, ["modelValue", "options"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", {
                    for: "rob",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Rob "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_64, [
                    _withDirectives(_createElementVNode("input", {
                      name: "rob",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((rob).value = $event)),
                      placeholder: "Remaining Quantity",
                      type: "number",
                      class: "form-control text-dark",
                      readonly: ""
                    }, null, 512), [
                      [_vModelText, rob.value]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _cache[37] || (_cache[37] = _createElementVNode("label", {
                    for: "est_rob",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Estimate ROB "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_67, [
                    _withDirectives(_createElementVNode("input", {
                      name: "est_rob",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((est_rob).value = $event)),
                      placeholder: "Est Remaining Quantity",
                      type: "number",
                      class: "form-control text-dark"
                    }, null, 512), [
                      [_vModelText, est_rob.value]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _cache[38] || (_cache[38] = _createElementVNode("label", {
                    for: "qty",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Qty "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_70, [
                    _withDirectives(_createElementVNode("input", {
                      name: "qty",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((qtyTemp).value = $event)),
                      placeholder: "Qty Required",
                      type: "number",
                      class: "form-control text-dark"
                    }, null, 512), [
                      [_vModelText, qtyTemp.value]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", _hoisted_72, [
                  _cache[39] || (_cache[39] = _createElementVNode("label", {
                    for: "remark",
                    class: "form-label label text-secondary"
                  }, [
                    _createTextVNode("Remark "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createElementVNode("div", _hoisted_73, [
                    _withDirectives(_createElementVNode("textarea", {
                      name: "remark",
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((remark).value = $event)),
                      placeholder: "Remark",
                      class: "form-control text-dark"
                    }, null, 512), [
                      [_vModelText, remark.value]
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              onClick: emptyStateModal
            }, " Close "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: addItemDixie
            }, " Add ")
          ])
        ])
      ])
    ])
  ], 64))
}
}

})